export const environment = {
    apiUrl: 'https://temka-dev.on-prod.ru',
    clientUrl: 'https://temka-dev.on-prod.ru'
};
